export function Input() {
    return {
        name: "input",
        label: "Step input",
        primitiveType: "array",
        itemsType: "mixed",
    };
}

export default Input;
